<template>
  <div>
    <div class="sector-data flex justify-space-between">
      <div class="sector-name">
        <span v-if="isAppraisal">Soft Skills Appraisal Form - </span>
        <span v-else>Technical Skills Appraisal Form - </span>
        {{ name }}</div>
      <div class="sector-questions">{{activeSectorIndex + 1}}/{{ sectorsSize }}</div>
    </div>
    <div class="questions-container">
      <Question v-for="question in questions" :key="question.id" :questionId="question.id" :text="question.text" :description="question.description" :order="question.ordering"/>
    </div>
  </div>
</template>

<script>
import Question from './Question.vue'

export default {
  name: 'Sector',
  components: {
    Question
  },
  computed: {
    activeSector() {
      return this.$store.getters.activeSector
    },
    activeSectorIndex() {
      return this.$store.getters.activeSectorIndex
    },
    sectors() {
      return this.$store.getters.sectors
    },
    isAppraisal() {
      return this.activeSector.id <= 6
    },
    sectorsSize() {
      return this.sectors.length
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    questions: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .sector-data {
    margin: 10px 0;
    color: black;
    .sector-name, .sector-questions {
      font-size: 18px;
      font-weight: 700;
    }
  }
  .questions-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0px 4px 7px 0px #455C721A;
    padding: 20px 10px;
  }
</style>
